// extracted by mini-css-extract-plugin
module.exports = {"outer":"AddMeal_outer__3URJy","form-input":"AddMeal_form-input__3lNnZ","text-input":"AddMeal_text-input__2nbxd","submit-row":"AddMeal_submit-row__3EEpq"};